module.exports = __webpack_public_path__ + "img/electronic_no_zone.c8650713.svg";